var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-item filter-item--checkbox" },
    [
      _c("h2", {
        staticClass: "filter-item__heading",
        domProps: { textContent: _vm._s(_vm.title) }
      }),
      _vm._v(" "),
      _c("checkbox", {
        attrs: { name: _vm.checkboxName, value: _vm.value },
        on: {
          checked: function(val) {
            return (_vm.value = val)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6707fde7", { render: render, staticRenderFns: staticRenderFns })
  }
}